/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import {
  BrandLogoIcon,
  DetailsAndFaqIconWmo,
  IcoMoon,
  PoweredByExtendIconWmo,
} from '@usap/uicomponents'
import {
  StyledBulletPointText,
  StyledCarPartsLogo,
  StyledCoverageContainer,
  StyledDivider,
  StyledDrawerContainer,
  StyledIconAndReasonContainer,
  StyledLinkAndLogoContainer,
  StyledLogoContainer,
  StyledPlusText,
  StyledProtectAutoPartText,
  StyledReasonsContainer,
  StyledReasonsText,
  StyledText,
  StyledReasonsHeading,
} from './WhatsCoveredDrawerContent.css'

type WhatsCoveredDrawerContentProps = {
  whyExtendHeading: string
  whyExtend1Icon: string
  whyExtend2Icon: string
  whyExtend1: string
  whyExtend2: string
  headline: string
  coverageBulletsHeading: string
  includedCoverageBulletPoints: string[]
  handleDetailsAndFaqVisit: () => void
}

const WhatsCoveredDrawerContent = ({
  whyExtendHeading,
  whyExtend1Icon,
  whyExtend2Icon,
  whyExtend1,
  whyExtend2,
  headline,
  coverageBulletsHeading,
  includedCoverageBulletPoints,
  handleDetailsAndFaqVisit,
}: WhatsCoveredDrawerContentProps) => (
  <StyledDrawerContainer>
    <StyledLogoContainer>
      <img
        alt="extend-logo"
        width="100"
        height="24"
        src="https://cld.partsimg.com/image/upload/d_noimage.jpg,c_pad,f_auto,q_auto:best,dpr_auto/carparts/shipping-protection/ExtendLogo.png"
      />
      <StyledPlusText>+</StyledPlusText>
      <StyledCarPartsLogo icon={BrandLogoIcon} />
    </StyledLogoContainer>

    <StyledProtectAutoPartText data-testid="ppp-whats-covered-drawer-description">{headline}</StyledProtectAutoPartText>

    <StyledCoverageContainer data-testid="ppp-whats-covered-drawer-coverage-bullet">
      <StyledText>{coverageBulletsHeading}</StyledText>
      {includedCoverageBulletPoints.map((coverage, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledBulletPointText key={`${coverage}-${idx}`}>
          {coverage}
        </StyledBulletPointText>
      ))}
    </StyledCoverageContainer>

    <StyledLinkAndLogoContainer>
      <div onClick={handleDetailsAndFaqVisit} style={{ cursor: 'pointer' }}>
        <IcoMoon icon={DetailsAndFaqIconWmo} />
      </div>
      <IcoMoon icon={PoweredByExtendIconWmo} />
    </StyledLinkAndLogoContainer>

    <StyledDivider />

    <StyledReasonsContainer>
      <StyledReasonsHeading>{whyExtendHeading}</StyledReasonsHeading>
      <StyledIconAndReasonContainer>
        <img alt="why-extend-heart-icon" src={whyExtend1Icon} />
        <StyledReasonsText>{whyExtend1}</StyledReasonsText>
      </StyledIconAndReasonContainer>
      <StyledIconAndReasonContainer>
        <img alt="why-extend-zero-dollar-icon" src={whyExtend2Icon} />
        <StyledReasonsText>{whyExtend2}</StyledReasonsText>
      </StyledIconAndReasonContainer>
    </StyledReasonsContainer>
  </StyledDrawerContainer>
)

export default WhatsCoveredDrawerContent
